import { Sidebar } from '@/layout/Sidebar';
import { TopBar } from '@/layout/TopBar';

export function AppShell({ children }) {
    return (
        <div className="tysoce-scope flex min-h-screen w-full bg-background text-foreground tysoce-grain">
            <Sidebar />
            <div className="relative z-10 flex min-w-0 flex-1 flex-col">
                <TopBar />
                <main className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-6">
                    {children}
                </main>
            </div>
        </div>
    );
}
